(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HubShowcasesService', HubShowcasesService);

    HubShowcasesService.$inject = ['HubShowcasesFactory', 'Upload', 'uploadFileConstants'];

    function HubShowcasesService(HubShowcasesFactory, Upload, uploadFileConstants) {

        var service = {
            listShowcases: listShowcases,
            getShowcase: getShowcase,
            saveShowcase: saveShowcase,
            updateShowcase: updateShowcase,
            deleteShowcases: deleteShowcases,
            uploadFile: uploadFile,
        };

        return service;

        function saveShowcase(showcase) {
            return HubShowcasesFactory.save(showcase).$promise;
        }

        function updateShowcase(showcase) {
            return HubShowcasesFactory.update(showcase).$promise;
        }

        function listShowcases(filter) {
            return HubShowcasesFactory.listAll(filter).$promise;
        }

        function getShowcase(id, ownerId) {
            return HubShowcasesFactory.get({
                id: id,
                ownerId: ownerId
            }).$promise;
        }

        function deleteShowcases(showcaseIds) {
            return HubShowcasesFactory.deletebyids({
                showcaseIds: showcaseIds
            }).$promise;
        }

        function uploadFile(file) {
            return Upload.upload({
                url: "/flyer/api/upload/file",
                contentType: "multipart/form-data",
                data: {
                    destination: uploadFileConstants.ASSET_FILE_DESTINATION.HUB_SHOWCASE,
                    file: file
                },
            });
        }
    }

})();
